import React from "react";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import AllocationList from "./AllocationList";

const Allotments = () => {
  return (
    <AllocationList
      status="ALLOTTED"
      title="Allotments"
      description="View finalized production allocations and their customer-wise quantities."
      icon={
        <AssignmentTurnedInOutlinedIcon
          sx={{
            fontSize: 27,
            color: "#027a48",
          }}
        />
      }
      basePath="/allotments"
    />
  );
};

export default Allotments;